import { takeEvery, put, call } from "redux-saga/effects";

import {
  getPaymentDtOk,
  getPaymentDtErr,
  getPaymentOk,
  getPaymentErr,
} from "./actions";

import {
  GET_PAYMENT_DT,
  GET_PAYMENT,
} from "./actionTypes";

import {
  getPaymentDt,
  getPayment,
} from "~/helpers/backendHelper";

/********** DATATABLE **********/

function* onGetPaymentDt({ payload: { params } }) {
  try {
    const response = yield call(getPaymentDt, params);
    yield put(getPaymentDtOk(response));
  } catch (error) {
    yield put(getPaymentDtErr(error));
  }
}

/********** SINGLE **********/


function* onGetPayment({ payload: { id } }) {
  try {
    const response = yield call(getPayment, id);
    yield put(getPaymentOk(response));
  } catch (error) {
    yield put(getPaymentErr(error));
  }
}

function* paymentSaga() {
  yield takeEvery(GET_PAYMENT_DT, onGetPaymentDt);
  yield takeEvery(GET_PAYMENT, onGetPayment);
}

export default paymentSaga;